export const approveBtnTitle = 'Approve';
export const disapproveBtnTitle = 'Disapprove';
export const revokeBtnTitle = 'Revoke';
export const confirmTitle = 'Confirm action';

export const approvalUnits = [
	{
		id: 0,
		approvalUnit: 'IT approval',
		approvalUsers: ['Rodney Peterson', 'Nansi Miranda'],
		updated: {
			updatedBy: 'Rodney Peterson',
			updatedAt: 1678787481000,
		},
		status: 'Revoked',
		notes: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
	},
	{
		id: 0,
		approvalUnit: 'PFI approval',
		approvalUsers: ['Kathleen Oneal', 'Rodney Peterson'],
		updated: {},
		status: 'Pending',
		notes: '',
	},
	{
		id: 0,
		approvalUnit: 'Street lightning approval',
		approvalUsers: ['Henry Lake'],
		updated: {},
		status: 'Pending',
		notes: '',
	},
	{
		id: 0,
		approvalUnit: 'Legal approval',
		approvalUsers: ['Johny Wilson'],
		updated: {},
		status: 'Pending',
		notes: '',
	},
	{
		id: 0,
		approvalUnit: 'Strategic procurement',
		approvalUsers: ['John Markhram'],
		updated: {},
		status: 'Pending',
		notes: '',
	},
];
